import * as types from './types'

const initialState = {
  coursesOverview: [],
  loading: false,
}

export default function coursesOverviewReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_COURSES_OVERVIEW:
      return { ...state, coursesOverview: action.payload }
    case types.SET_COURSES_OVERVIEW_LOADING:
      return { ...state, loading: true }
    default:
      return state
  }
}
